import debounce from "../util/debounce";

export default class NavScroll {
  constructor() {
    this.nav = document.querySelector(".js-nav");
    this.navTrigger = document.querySelector(".js-nav-trigger-container");
    this.navLine = document.querySelector(".js-nav-line");

    this.lastScrollTop = 0;

    this.checkScroll = this.checkScroll.bind(this);
  }

  init() {
    this.events();
  }

  events() {
    window.addEventListener("scroll", debounce(this.checkScroll, 50));
  }

  // TODO: menu hiden bij scroll (niet kunnen scrollen!)
  checkScroll() {
    var st = window.pageYOffset || document.documentElement.scrollTop;

    if (st < this.lastScrollTop || st < 120) {
      this.nav.classList.add("is-visible");
      this.navTrigger.classList.add("is-visible");
      this.navLine.classList.add("is-visible");
    } else {
      this.nav.classList.remove("is-visible");
      this.navTrigger.classList.remove("is-visible");
      this.navLine.classList.remove("is-visible");
    }
    this.lastScrollTop = st;
  }

  render() {
    //
  }
}



// WEBPACK FOOTER //
// ./scripts/components/navScroll.js